import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { resetPassword } from '~/api';

import {
  Container,
  ForgotPasswordForm,
  TextField,
  Button,
  ErrorMessage,
} from '~/components/_layouts/forms/styles';
import Loading from '~/components/Loading';

export default function PasswordReset({ match }) {
  const {
    params: { token, userId },
  } = match;
  const [password, setPassword] = useState(null);
  const [repeatPassword, setRepeatPassword] = useState(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      if (password === repeatPassword) {
        await resetPassword(userId, token, password);
        history.push('/signin');
      } else {
        setError(true);
      }
    } catch (resetError) {
      toast.error('Erro ao definir nova senha!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <ForgotPasswordForm>
        <div className="centered reset-password">Digite nova senha</div>
        <form onSubmit={(event) => handleSubmit(event)}>
          <TextField
            type="password"
            label="Senha"
            value={password}
            required
            variant="outlined"
            onChange={(event) => setPassword(event.target.value)}
            fullWidth
          />

          <TextField
            type="password"
            label="Repetir senha"
            value={repeatPassword}
            required
            variant="outlined"
            onChange={(event) => setRepeatPassword(event.target.value)}
            fullWidth
          />

          {error && <ErrorMessage>Senhas não são iguais</ErrorMessage>}

          <Button
            disabled={isLoading}
            fullWidth
            type="submit"
            variant="outlined"
          >
            Resetar senha
            {isLoading && <Loading buttonLoading />}
          </Button>
        </form>
      </ForgotPasswordForm>
    </Container>
  );
}

PasswordReset.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string.isRequired,
      userId: PropTypes.number.isRequired,
    }),
  }).isRequired,
};
